import { useNavigate } from "react-router-dom";
import "./CategoryCard.css";
import React from "react";
import PrimaryButton from "../../../Atoms/Buttons/Primary/PrimaryButton";

function CategoryCard({ category }) {
  const navigate = useNavigate();

  // Calculate total members range from all age groups
  const getMembersRange = () => {
    if (!category.ageGroups || category.ageGroups.length === 0) return null;

    const allMinMembers = category.ageGroups
      .map((ag) => ag.minMembers)
      .filter((val) => val !== null && val !== undefined);
    const allMaxMembers = category.ageGroups
      .map((ag) => ag.maxMembers)
      .filter((val) => val !== null && val !== undefined);

    if (allMinMembers.length === 0 && allMaxMembers.length === 0) return null;

    const minMember =
      allMinMembers.length > 0 ? Math.min(...allMinMembers) : null;
    const maxMember =
      allMaxMembers.length > 0 ? Math.max(...allMaxMembers) : null;

    if (minMember !== null && maxMember !== null) {
      return `Min: ${minMember} | Max: ${maxMember}`;
    } else if (minMember !== null) {
      return `Min: ${minMember}`;
    } else if (maxMember !== null) {
      return `Max: ${maxMember}`;
    }
    return null;
  };

  const membersRange = getMembersRange();

  return (
    <div className="categoryCard">
      <div className="categoryCardHeader">
        <h2>{category.name}</h2>
        <span
          className={`statusBadge ${
            category.active ? "statusActive" : "statusInactive"
          }`}
        >
          {category.active ? "Active" : "Inactive"}
        </span>
      </div>
      {category.ageGroups && category.ageGroups.length > 0 && (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div className="categoryInfo" style={{ minWidth: "50%" }}>
            <h3>Age Groups:</h3>
            <p>
              {category.ageGroups.length}{" "}
              {category.ageGroups.length === 1 ? "Group" : "Groups"}
            </p>
          </div>
          {membersRange && (
            <div className="categoryInfo" style={{ minWidth: "50%" }}>
              <h3>Members:</h3>
              <p>{membersRange}</p>
            </div>
          )}
        </div>
      )}
      {(!category.ageGroups || category.ageGroups.length === 0) && (
        <div className="categoryInfo">
          <p className="noAgeGroups">No age groups configured</p>
        </div>
      )}
      <div className="categoryCardButton">
        <PrimaryButton
          classBtn={"center categoryButton"}
          text={"View Details"}
          style={{
            textTransform: "capitalize",
            borderRadius: "5px",
            color: "var(--text-secondary)",
            backgroundColor: "var(--primary)",
            height: "40px",
            padding: "0 15px",
            minWidth: "100px",
            textWrap: "noWrap",
            marginTop: "0px",
          }}
          click={(e) => {
            e.stopPropagation();
            navigate(`/categories/${category.id}`);
          }}
        />
      </div>
    </div>
  );
}

export default CategoryCard;
